import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isShowLoading: false, // 全局 loading
    // 左侧菜单栏数据
    menuItems: [
      // {
      //   name: 'home', // 要跳转的路由名称 不是路径
      //   size: 18, // icon大小
      //   type: 'ios-home', // icon类型
      //   text: '主页', // 文本内容
      // },
      {
        name: 'PPuser', // 要跳转的路由名称 不是路径
        size: 18, // icon大小
        type: 'ios-people', // icon类型
        text: '用户管理', // 文本内容
        hidden: true,
      },
      {
        name: 'ArtificialServices', // 要跳转的路由名称 不是路径
        size: 18, // icon大小
        type: 'ios-chatbubbles', // icon类型
        text: '人工服务', // 文本内容
        hidden: true,
      },
      {
        text: '积分',
        type: 'ios-calculator',
        size: 18, // icon大小
        name: "Pmanagement",
        hidden: true,
        children: [
          {
            name: 'Pmanagement', // 要跳转的路由名称 不是路径
            size: 18, // icon大小
            type: 'ios-podium', // icon类型
            text: '设备积分管理', // 文本内容
            hidden: true,
          },
          {
            name: 'toExamine', // 要跳转的路由名称 不是路径
            size: 18, // icon大小
            type: 'ios-podium-outline', // icon类型
            text: '积分审核', // 文本内容
            hidden: true,
          },
        ]
      },
      {
        text: '礼品',
        type: 'ios-cart',
        size: 18, // icon大小
        name: 'Gmanagement',
        hidden: true,
        children: [
          {
            name: 'Gmanagement', // 要跳转的路由名称 不是路径
            size: 18, // icon大小
            type: 'ios-stats', // icon类型
            text: '礼品管理', // 文本内容
            hidden: true,
          },
          {
            name: 'grant', // 要跳转的路由名称 不是路径
            size: 18, // icon大小
            type: 'ios-stats-outline', // icon类型
            text: '礼品发放', // 文本内容
            hidden: true,
          },
        ]
      },
      {
        text: '系统设置',
        type: 'md-settings',
        size: 18, // icon大小
        name: 'banner',
        hidden: true,
        children: [
          {
            name: 'banner',
            text: 'banner管理',
            type: 'md-images',
            size: 18, // icon大小
            // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
            hidden: true,
          },
          // {
          //   name: 'recommend',
          //   text: '推荐位管理',
          //   type: 'ios-redo',
          //   size: 18, // icon大小 
          //   hidden: false,
          // },
          {
            name: 'column',
            text: '底页栏目',
            type: 'md-menu',
            size: 18, // icon大小 底页链接管理
            hidden: true,
          },
          {
            name: 'footlist',
            text: '底页链接管理',
            type: 'ios-paper-plane',
            size: 18, // icon大小 底页链接管理
            hidden: true,
          },
          {
            name: 'RolePermissions',
            text: '角色权限',
            type: 'md-key',
            size: 18, // icon大小 底页链接管理
            hidden: true,
          },
          {
            name: 'staff',
            text: '员工管理',
            type: 'ios-person',
            size: 18, // icon大小 底页链接管理
            hidden: true,
          },
          {
            name: 'ProductLine',
            text: '产品线管理',
            type: 'md-git-network',
            size: 18, // icon大小 底页链接管理
            hidden: true,
          },
          {
            name: 'GiftSpec',
            text: '礼品规格管理',
            type: 'md-cube',
            size: 18, // icon大小 底页链接管理
            hidden: true,
          },
          {
            name: 'agreement',
            text: '版权协议',
            type: 'ios-aperture',
            size: 18, // icon大小 协议权限
            hidden: true,
          }
        ],
      },
    ],
  },
  mutations: {
    setMenus(state, items) {
      state.menuItems = [...items]
    },
    setLoading(state, isShowLoading) {
      state.isShowLoading = isShowLoading
    },
  },
})

export default store